import React from 'react';
import { Numbers, Select } from '@weezevent/nacre';
import css from '../modal-popup.module.css';
import i18n from 'i18next';
import useAppContext from '../../../../../../../context/useAppContext';

export default function ModalItem({ currency, rates, category, inventories, onSelectRate, onPickerChange, currentInventory }) {
    const { language: locale } = i18n;
    const [{ event }] = useAppContext();

    const ratesToMap = React.useMemo(() => {
        const actualInventory = inventories.find(inv => inv.uuid === currentInventory);

        if (event.use_sessions) {
            return rates.filter(rate => rate.sessionId === actualInventory.uuid && rate.resolved_category === category.uuid);
        }

        return rates.filter(rate => rate.inventories?.includes(actualInventory.uuid) && rate.resolved_category === category.uuid);
    }, [inventories, currentInventory, rates, event]);

    return ratesToMap
        .filter(rate => rate.active)
        .map(rate => {
            let options = [];
            let limit = rate.available < 15 ? rate.available : 16;
            for (let i = 0; i < limit; i++) {
                // Nacre Select doesn't seem to handle or display zeros, instead the text is stringified and value is set to null to respect further validation conditions
                options.push({
                    text: i === 0 ? '0' : i,
                    value: i === 0 ? null : i
                });
            }

            return (
                <div className={css['modal-popup-item']} key={rate.id}>
                    <span className={css['popup-item-label']}>{rate.resolved_name}</span>
                    <span className={css['popup-item-selector']}>
                        <Numbers className={css['price-tag']} value={rate.resolved_price} locale={locale} currency={currency} showNullDecimal={false} />
                        <Select
                            onChange={value => {
                                // Store information into selected_rates
                                onSelectRate(value, 'quantity', rate, currentInventory);
                                // Send information to the parent to unabled the button to add
                                onPickerChange(rate.name, value);
                            }}
                            options={options}
                            placeholder={'0'}
                            size={'mini'}
                        />
                    </span>
                </div>
            );
        });
}
